import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService, Page } from '@markant-platform/shared/data-access';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PlatformNewsItem } from './platform-news.model';

@Injectable({ providedIn: 'root' })
export class PlatformNewsService {
  apiUrl: string = AppConfigService.appConfiguration.apiUrl['platformNewsService'];

  constructor(private http: HttpClient) {}

  // Request a list of all platform news
  getPlatformNews(
    page: number,
    size: number,
    periodFrom: string,
    periodTo: string,
    newestFirst = true,
    categories?: string[]
  ): Observable<Page<PlatformNewsItem>> {
    let categoriesToApi = new HttpParams();

    if (categories) {
      categories.forEach(item => {
        categoriesToApi = categoriesToApi.append('categories', item);
      });
    }

    return this.http.get<Page<PlatformNewsItem>>(
      `${this.apiUrl}?newestFirst=${newestFirst}&periodFrom=${periodFrom}&periodTo=${periodTo}&page=${page}&size=${size}`,
      { params: categoriesToApi }
    );
  }

  getSingleNewsItem(id: string | null): Observable<PlatformNewsItem> {
    return this.http.get<PlatformNewsItem>(`${this.apiUrl}/${id}`);
  }

  getNewsCategories(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/categories`);
  }

  downloadNewsItemsMedia(imgId: string): Observable<Blob> {
    const httpOptions = {
      responseType: 'blob' as 'json',
    };

    return this.http.get<Blob>(`${this.apiUrl}/storage/file/${imgId}`, httpOptions);
  }
}
